
import React, { useState, useEffect } from 'react';
import { FormLabel, FormValue } from './FormLabel';
import { Button } from "reactstrap"
import { useEdit } from '../../Services/EditContext';
import useFetch from '../../Services/useFetch';
import LoadingAnimation from './LoadingAnimation';
import Selector from './SelectorNoForm';

interface StringSelectorProps {
    string?: boolean;
    label: string;
    endpoint: string;
    onChange?: (value: unknown) => void | Promise<void>;
    value: string;
}

const SelectSettingNoForm = ({ string, label, endpoint, onChange, value }: StringSelectorProps) => {
    const [selection, setSelection] = useState<{ label: string, value: string } | undefined>();
    const [options, setOptions] = useState<{ label: string, value: string }[]>([]);

    const editar = useEdit();

    const edit = editar.length ? editar[0] : true;
    const [currencies, loading, error, refresh] = useFetch<{ value: string }[]>(endpoint);


    useEffect(() => {
        if (currencies instanceof Array) {
            const options = currencies.map(x => { return string ? { label: x, value: x } : { label: x.value, value: x.value }; });
            setOptions(options as any);
        }
    }, [currencies, string]);
    useEffect(() => {
        if (options && value) {

            const list = value.split(',');
            const newOps = list.map(x => options.find(y => x === y.value));
            setSelection(newOps as any);
        }
    }, [value, options])

    const onSelectChange = val => {
        onChange?.(val.value)

    }
    return <React.Fragment>
        {label ? < FormLabel style={{ display: 'block' }}>
            {label}
        </FormLabel> : null}
        {edit ? <Selector onChange={onSelectChange} value={selection ?? null} options={options.map(option => option.value)} /> : <FormValue>{value}</FormValue>}
        {loading ? <LoadingAnimation height={50} /> : error ? <h3>Error<Button from onClick={() => refresh()}>Retry</Button></h3> : null}

    </React.Fragment>
};

export default SelectSettingNoForm;